/**
 * The surgery waitlist fields - clinician, operative eye, procedures, preferred timeframe, comments and the
 * automation task - for the "Add to Surgery Waitlist" modal.
 */
app.component("surgeryWaitlistFields", {
	templateUrl: "app/src/js/components/surgeryWaitlist/surgeryWaitlistFields.html",
	controller: "surgeryWaitlistFieldsController",
	bindings: {
		section: "=",
		showCpac: "<",
		onAutomationTaskChange: "&",
	},
});

app.controller("surgeryWaitlistFieldsController", [
	"$scope",
	"$filter",
	"Session",
	"surgeryWaitlistFormService",
	function ($scope, $filter, Session, surgeryWaitlistFormService) {
		const ctrl = this;

		$scope.today = $filter("date")(new Date(), "dd-MMMM-yyyy");
		$scope.isDHBPublic = Session.practice.type === "DHB_PUBLIC";
		$scope.clinicianOptions = [];

		ctrl.$onInit = function () {
			if (!ctrl.section.clinician_user_id) {
				ctrl.section.clinician_user_id = Number(Session.userId);
			}

			surgeryWaitlistFormService.getClinicianOptions().then(function (options) {
				$scope.clinicianOptions = options;
			});
		};

		$scope.hasRequiredTimeframe = function () {
			return surgeryWaitlistFormService.hasRequiredTimeframe(ctrl.section);
		};

		$scope.hasPrimaryProcedure = function () {
			return surgeryWaitlistFormService.hasPrimaryProcedure(ctrl.section);
		};

		function toProcedure(concept, laterality) {
			return {
				snomed_concept: {
					concept_id: concept.concept_id,
					fsn: concept.fsn,
					pt: concept.pt,
				},
				laterality: laterality,
			};
		}

		$scope.primaryProcedureODCallback = function (form) {
			ctrl.section.primary_procedure_od = form && form.diagnosis_object ? toProcedure(form.diagnosis_object, "OD") : null;
		};

		$scope.primaryProcedureOSCallback = function (form) {
			ctrl.section.primary_procedure_os = form && form.diagnosis_object ? toProcedure(form.diagnosis_object, "OS") : null;
		};

		// Each eye's secondary procedures live in one shared list, so updating one eye keeps the other's.
		function setSecondaryProcedures(form, laterality) {
			const otherEye = (ctrl.section.secondary_procedure_list || []).filter((t) => t.laterality !== laterality);
			if (form) {
				ctrl.section.secondary_procedure_list = [...form.map((t) => toProcedure(t, laterality)), ...otherEye];
			}
		}

		$scope.secondaryProcedureODCallback = function (form) {
			setSecondaryProcedures(form, "OD");
		};

		$scope.secondaryProcedureOSCallback = function (form) {
			setSecondaryProcedures(form, "OS");
		};

		// dd/mm/yyyy to a date string, for the second datepicker's lower limit.
		$scope.convertDate = function (date) {
			if (date) {
				const parts = date.split("/");
				return new Date(parts[2] + "-" + parts[1] + "-" + parts[0]).toString();
			}
			return new Date().toString();
		};
	},
]);
